export default __webpack_public_path__ + "static/media/border-right.d104adc8.svg";